export var colorWhite = '#fff';
export var colorWhite2 = '#f2f5f8';
export var colorWhite3 = '#fefbf3';
export var colorBlack = '#000';
export var colorBlack900 = '#111512';
export var colorBlack500 = '#1E2621';
export var colorBlack300 = '#454D49';
export var colorBlack200 = '#696F6B';
export var colorGrey = '#575757';
export var colorGreyDark = '#2d2d2d';
export var colorGreyLight = '#93a4ac';
export var colorGrey40 = '#E6E6E6';
export var colorGrey50 = '#F2F3F2';
export var colorGrey100 = '#E5E5E5';
export var colorGrey200 = '#CACCCB';
export var colorGrey300 = '#A8B0AC';
export var colorGrey400 = '#87928C';
export var colorGrey700 = '#2B2B2B';
export var colorGrey900 = '#252525';
export var colorRed = '#df3014';
export var colorRedLight = '#f5c1b8';
export var colorOrange = '#ff7500';
export var colorYellow = '#fac917';
export var colorGreen400 = '#35A47C';
export var green50 = '#298662';
export var primary400 = '#35A47C';
export var colorGreen50 = '#F3FAF7';
export var colorBlue = '#244696';
export var colorBlue10 = '#5076C0';
export var colorBlueLight = '#cbdaf4';